import validate from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45global from "/var/www/marketplace-dev.ingeniuscloud.net/middleware/admin.global.ts";
import inactivity_45global from "/var/www/marketplace-dev.ingeniuscloud.net/middleware/inactivity.global.ts";
import partner_45auth_45guard_45global from "/var/www/marketplace-dev.ingeniuscloud.net/middleware/partnerAuthGuard.global.ts";
import session_45global from "/var/www/marketplace-dev.ingeniuscloud.net/middleware/session.global.ts";
import manifest_45route_45rule from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45global,
  inactivity_45global,
  partner_45auth_45guard_45global,
  session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-create-product": () => import("/var/www/marketplace-dev.ingeniuscloud.net/middleware/checkCreateProduct.ts"),
  "check-edit-product": () => import("/var/www/marketplace-dev.ingeniuscloud.net/middleware/checkEditProduct.ts"),
  "check-order-owner": () => import("/var/www/marketplace-dev.ingeniuscloud.net/middleware/checkOrderOwner.ts"),
  "check-profile-user": () => import("/var/www/marketplace-dev.ingeniuscloud.net/middleware/checkProfileUser.ts"),
  "require-province": () => import("/var/www/marketplace-dev.ingeniuscloud.net/middleware/requireProvince.ts"),
  "sanctum:auth": () => import("/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}